<template>
  <div id="app">
    <div class='container-fluid'>
    <Menu :user="$root.user"/>
    </div>
    <div class="container">
      <div class="row">
        <div class="offset-md-3 col-lg-6 col-md-12">
          <LeftSide/>
        </div>
        <div class="col-lg-9 col-md-12">
          <CentralSide/>
        </div>
      </div>
      <FooterSide/>
    </div>
  </div>
</template>

<script>
import Menu from "./components/Menu/Menu";
import LeftSide from "./components/LeftSide/LeftSide";
import CentralSide from "./components/CentralSide/CentralSide";
import FooterSide from "./components/FooterSide/FooterSide";


export default {
  name: "app",
  components: {
    Menu,
    LeftSide,
    CentralSide,
    FooterSide
  }
};
</script>